// extracted by mini-css-extract-plugin
module.exports = {"header":"i_II","body":"i_IJ","wrapper":"i_IK"};